import { render, staticRenderFns } from "./NewReview.vue?vue&type=template&id=0bd27d64&scoped=true&"
import script from "./NewReview.vue?vue&type=script&lang=js&"
export * from "./NewReview.vue?vue&type=script&lang=js&"
import style0 from "./NewReview.vue?vue&type=style&index=0&id=0bd27d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd27d64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VChip,VChipGroup,VPagination})
